import '../../modules/mode-components';

import * as angular from 'angular';

class GroupFacepileController {
  static $inject = [];

  public group: any;
  public size: string;
  private initial: string;
  private faceSize: number;

  constructor() {}

  $onInit() {
    const name = this.group.name.split(' ');
    this.initial = this.group.name ? this.group.name.charAt(0).toUpperCase() : '?';
    this.faceSize = Math.ceil(parseInt(this.size, 10) * 0.3) * 2;
  }
}

const groupFacepileComponent: angular.IComponentOptions = {
  bindings: {
    group: '<',
    size: '@',
  },
  template: `
<div class="group-facepile-component" style="width:{{ ctrl.size }}px;height:{{ ctrl.size }}px;">
  <div class="mode-avatar mode-avatar-initials mode-icon-{{ ctrl.size }} facepile-initials">{{ ctrl.initial }}</div>
  <div class="mode-avatar mode-avatar-initials mode-icon-{{ ctrl.faceSize }} facepile-1"></div>
  <div class="mode-avatar mode-avatar-initials mode-icon-{{ ctrl.faceSize }} facepile-2"></div>
  <div class="mode-avatar mode-avatar-initials mode-icon-{{ ctrl.faceSize }} facepile-3"></div>
  <div class="mode-avatar mode-avatar-initials mode-icon-{{ ctrl.faceSize }} facepile-4"></div>
</div>
`,
  controller: GroupFacepileController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('groupFacepile', groupFacepileComponent);
